export default __webpack_public_path__ + "YWP-light.svg";